module.exports = __webpack_public_path__ + "static/media/lv.0e4c52e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lv.png
// module id = 722
// module chunks = 0